// core version + navigation, pagination modules:
import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay} from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
if(document.querySelector('.ume-intra-hero-block-slider')){
    let autoplay = false;
    if (!mediaQuery || mediaQuery.matches) {

    } else {
        autoplay = {
            delay: 4500,
        }
    }
    const allSliders = document.querySelectorAll('.ume-intra-hero-block-slider');
    allSliders.forEach(slider =>{
        const parent = slider.closest('.ume-intra-hero-block');
        const pagination = parent.querySelector('.swiper-pagination');
        const swiper = new Swiper(slider, {
            // configure Swiper to use modules
            modules: [Navigation, Pagination, Autoplay],
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: autoplay,
            pagination: {
                el: pagination,
                type: 'bullets',
                clickable: true,
            },
            slidesPerView: 1,
            spaceBetween: 0,
            /* on: {
                 lock: function () {

                     this.el.classList.add('ume-intra-slider-block-locked');
                 },
                 unlock: function () {
                     this.el.classList.remove('ume-intra-slider-block-locked');
                 },
             },*/
        });
    })
}


const handleScrollDown = () =>{
    document.addEventListener('click', ev =>{
        if(!ev.target.closest('.ume-hero-block-inner-down-button')) return;
        let button = ev.target.closest('.ume-hero-block-inner-down-button');
        let hero = button.closest('.ume-intra-main');
        let firstSection = hero.querySelector('.ume-intra-section-block');
        if(firstSection){
            firstSection.scrollIntoView();
        }

    })
}
window.addEventListener('load', () => {
    handleScrollDown();



});